<template>
  <div class="courseware-list">
    <div class="list-item" v-for="el in info" :key="el.id">
      <div :style="`padding-left: ${padding}px`">
        <VIconFont :type="typeList[el.attmType].icon" class="icon" />
        <span>{{ el.attmName }}</span>
      </div>
      <div>
        <div class="status" :class="[`status-${el.studyStatus}`]">
          {{ el.studyStatus === "2" ? "已完成" : "未完成" }}
        </div>
      </div>
      <div v-if="(el.attmType === '3' || el.attmType === '4') && el.studyTime">
        {{ formatDuring(el.studyTime) }}
      </div>
      <div v-if="isType(el.attmType) && el.studyCount">
        点击{{ el.studyCount }}次
      </div>
    </div>
  </div>
</template>

<script>
import VIconFont from "@/components/iconFont";
export default {
  props: {
    padding: {
      type: Number,
      default: 46,
    },
    info: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    VIconFont,
  },
  data() {
    return {
      typeList: [
        {},
        {
          title: "文档",
          icon: "icon-doc",
          type: "1",
        },
        {
          title: "图片",
          icon: "icon-tupian",
          type: "2",
        },
        {
          title: "视频",
          icon: "icon-shipin_n",
          type: "3",
        },
        {
          title: "音频",
          icon: "icon-yinpin",
          type: "4",
        },
        {
          title: "SCORM互动",
          icon: "icon-ziyuan1",
          type: "5",
        },
        {
          title: "PDF文档",
          icon: "icon-pdf",
          type: "6",
        },
        {
          title: "PPT文档",
          icon: "icon-ppt",
          type: "7",
        },
      ],
    };
  },
  methods: {
    isType(type) {
      return (
        type === "1" ||
        type === "2" ||
        type === "5" ||
        type === "6" ||
        type === "7"
      );
    },

    formatDuring(time) {
      let hour = Math.floor(time / 60 / 60);

      hour = hour.toString().padStart(2, "0");

      let minute = Math.floor(time / 60) % 60;

      minute = minute.toString().padStart(2, "0");

      let second = Math.floor(time) % 60;

      second = second.toString().padStart(2, "0");

      return `${hour}:${minute}:${second}`;
    },
  },
};
</script>

<style scoped lang="scss">
.courseware-list {
  .list-item {
    height: 48px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 400;
    color: #262626;
    line-height: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    .icon {
      color: #c9d0d6;
      margin-right: 8px;
    }
    &:hover {
      color: #ff7c15;
      background: #fff6ef;
      .icon {
        color: #ff7c15;
      }
    }
    > :first-child {
      width: 758px;
      padding-right: 24px;
    }
    > :nth-child(2) {
      width: 263px;
      padding-right: 24px;
      .status {
        width: 52px;
        height: 22px;
        border-radius: 11px;
        border: 1px solid #ff4d4f;
        font-size: 12px;
        font-weight: 400;
        color: #ff4d4f;
        line-height: 20px;
        text-align: center;
      }
      .status-1 {
        border-color: #ff4d4f;
        color: #ff4d4f;
      }
      .status-2 {
        border-color: #52c41a;
        color: #52c41a;
      }
    }
    > :nth-child(3) {
      width: 131px;
    }
  }
}
</style>
